import {ActionTree} from "vuex";
import {PoolFilter, PoolItem, PoolsState} from "@/store/settings/pools/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<PoolsState, RootState> = {
  getPools: ({commit}, data: PoolFilter) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/pools', params: data})
        .then(resp => {
          if (data?.page_number > 1) {
            commit('pushPools', resp.data.pools);
          } else {
            commit('setPools', resp.data.pools);
          }
          resolve(resp.data?.pools)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getPoolItem: ({commit},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/pools/${id}`})
        .then((resp:any) => {
          let poolItem = <PoolItem>resp.data;
          poolItem.id = id;
          commit('setPoolItem', poolItem);
          resolve(poolItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  savePool: ({commit}, data:PoolItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/pools/' + (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deletePool: ({commit}, data: PoolItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/pools/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getPoolNumbers: ({commit}, data: { id: number, msisdn?: string, page_number?: number }) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/pools/${data.id}/numbers`, params: data})
        .then((resp:any) => {
          commit('setPoolNumbers', resp.data.originators);
          resolve(resp.data.originators)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  importPoolNumbers: ({commit}, data: any) => {
    commit('setLoading', true);
    const { id, ...body } = data;
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `/acapi/pools/${id}/numbers/import`,
        data: { name: body.name, file: body.file, delimeter: body.delimeter }
      })
        .then((resp:any) => {
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  addPoolNumbers: ({commit}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `/acapi/pools/${data.id}/numbers`,
        data: { originators: data.originators }
      })
        .then((resp:any) => {
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  updatePoolNumber: ({commit}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: `/acapi/pools/${data.id}/numbers/${data.numberId}`,
        data: { msisdn: data.msisdn }
      })
        .then((resp:any) => {
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deletePoolNumbers: ({commit}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/pools/${data.id}/numbers`,
        data: { originators_ids: data.originators_ids }
      })
        .then((resp:any) => {
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
}